import ExternalLink from "@/components/ui/ExternalLink";
import InfoPageLayout from "@/components/templates/infoPage/InfoPageLayout";
import InfoPageSection from "@/components/templates/infoPage/InfoPageSection";
import {
  InfoPageList as Ul,
  InfoPageListItem as Li,
} from "@/components/templates/infoPage/InfoPageList";
import OfficialLINE from "@/components/ui/OfficialLINE";
import { OFFICIAL_EMAIL, OFFICIAL_LINE } from "@/constants/common";

const PrivacyPolicyPage = () => {
  const lastUpdated = new Date().toISOString().slice(0, 10);

  return (
    <InfoPageLayout
      pageTitle="隱私權政策"
      bannerImage={{
        default: "/images/banner-shopping-info.jpg",
        desktop: "/images/banner-shopping-info.jpg",
      }}
      breadcrumbs={[{ label: "首頁", path: "/" }, { label: "隱私權政策" }]}
      ogImage="/images/banner-shopping-info-og.jpg"
      bannerImagAlign="right"
    >
      <p>
        小院咖啡（以下簡稱「本網站」）重視您的個人資料與隱私保護。本政策說明我們在您使用購物車、結帳、訂單查詢與客服聯繫（LINE/Email）等服務時，如何蒐集、使用、保護與分享您的個人資料。
      </p>

      <InfoPageSection title="我們蒐集的資料與範圍">
        <Ul>
          <Li>訂單與出貨資訊：包含姓名、聯絡電話、Email、收件地址、訂購商品、備註。</Li>
          <Li>
            服務使用資訊：包含購物車內容、下單紀錄、訂單狀態、與我們的聯繫紀錄（例如透過
            <OfficialLINE /> 或 Email）。
          </Li>
          <Li>
            技術與裝置資訊：為確保結帳與購物車正常運作，我們可能使用必要的 Cookie、Session Storage
            或 LocalStorage，以維持登入或購物車狀態與偏好設定。
          </Li>
          <Li>
            網站分析資訊：為改善網站服務與使用體驗，我們使用 Google Analytics（GA4）與 Microsoft
            Clarity 等分析工具，可能蒐集您瀏覽頁面、點擊行為、停留時間、裝置資訊、IP
            位址（經匿名化處理）等使用數據，以及透過 Microsoft Clarity
            錄製部分使用者操作畫面（Session Replay）以進行熱點圖分析。
          </Li>
          <Li>
            付款相關：若您選擇信用卡結帳（綠界金流
            ECPay），付款資料由金流服務商處理，本網站不會接觸或儲存您的完整信用卡資料。
          </Li>
        </Ul>
      </InfoPageSection>

      <InfoPageSection title="使用目的與法定依據">
        <Ul>
          <Li>履行契約：處理訂單、金流請款、出貨、退換貨與售後服務。</Li>
          <Li>客服聯繫：回覆您的詢問、提供訂單與出貨通知。</Li>
          <Li>法令遵循：稅務、會計與相關規範之保存要求。</Li>
          <Li>
            服務優化：透過 Google Analytics 與 Microsoft Clarity
            等分析工具，分析網站使用行為、流量來源、頁面表現與使用者互動，以改善網站流程與使用體驗。此類分析資料均經過匿名化處理，不會直接識別您的個人身分。
          </Li>
          <Li>
            行銷通知：在您同意的情況下，提供活動或商品資訊，您可隨時透過 LINE 或 Email 要求停用。
          </Li>
        </Ul>
      </InfoPageSection>

      <InfoPageSection title="資料分享與第三方" id="sharing">
        <Ul>
          <Li>
            金流服務商：為完成交易而提供必要資料予綠界金流（ECPay）等金流廠商，付款頁面透過其安全機制處理。
          </Li>
          <Li>
            配送與物流：為出貨與配送提供必要資訊予承運商（如
            7-11、全家、萊爾富、郵局等或其合作系統）。
          </Li>
          <Li>
            網站分析服務商：為進行網站分析與改善服務體驗，我們使用 Google Analytics（Google LLC）與
            Microsoft Clarity（Microsoft
            Corporation）等服務。這些服務商會根據其隱私權政策處理使用數據，相關資料可能儲存於台灣或境外。您可透過瀏覽器設定或擴充功能限制分析工具的運作。
          </Li>
          <Li>
            受託與雲端服務：於營運所需範圍內，委由受託廠商或雲端服務處理並儲存資料；我們將確保其遵循資料保護義務。
          </Li>
        </Ul>
        <p>除上述情形或法令要求外，非經您同意，我們不會將您的個人資料提供給其他第三方。</p>
      </InfoPageSection>

      <InfoPageSection title="Cookie 與本地儲存" id="cookies">
        <Ul>
          <Li>
            功能性 Cookie：我們使用維持網站基本功能所必須的
            Cookie（例如購物車、結帳流程與偏好設定）。
          </Li>
          <Li>
            分析性 Cookie：為進行網站分析與改善服務，我們使用 Google Analytics 與 Microsoft Clarity
            的分析
            Cookie，這些工具會記錄您的瀏覽行為、點擊、頁面停留時間等使用數據，並可能錄製部分操作畫面以進行熱點圖分析。此類資料均經過匿名化處理，不會直接識別您的個人身分。
          </Li>
          <Li>目前不使用第三方廣告追蹤 Cookie。</Li>
          <Li>
            您可於瀏覽器調整 Cookie 設定；但若停用功能性
            Cookie，可能導致購物與結帳功能受影響。若停用分析性
            Cookie，將不影響網站基本功能，但我們將無法透過分析數據改善服務品質。
          </Li>
        </Ul>
      </InfoPageSection>

      <InfoPageSection title="資料保存期間與地點" id="retention">
        <Ul>
          <Li>為達成蒐集之特定目的所必須之期間內保存。</Li>
          <Li>訂單、帳務與會計相關資料，依法令（如稅務或商業會計法）需保存一定年限。</Li>
          <Li>
            資料可能儲存於我們或受託廠商之系統或雲端環境，位置可能在台灣或境外，並採取必要保護措施。
          </Li>
        </Ul>
      </InfoPageSection>

      <InfoPageSection title="您的權利" id="your-rights">
        <p>您可依個人資料保護相關法令，對您的個人資料行使以下權利：</p>
        <Ul>
          <Li>查詢或請求閱覽、製給副本。</Li>
          <Li>請求補充或更正。</Li>
          <Li>請求停止蒐集、處理或利用。</Li>
          <Li>請求刪除（惟依法需保存者不在此限）。</Li>
        </Ul>
        <p>
          行使方式：請透過 <OfficialLINE /> 或 Email（{OFFICIAL_EMAIL}
          ）與我們聯繫，我們將於確認身分後儘速處理。
        </p>
      </InfoPageSection>

      <InfoPageSection title="資訊安全" id="security">
        <Ul>
          <Li>採取權限控管、最小必要存取原則，僅限授權人員處理您的資料。</Li>
          <Li>透過加密傳輸（HTTPS/TLS）與必要的安全措施保護資料。</Li>
          <Li>
            信用卡資料由金流商（例如綠界金流 ECPay）於其安全環境處理，本網站不儲存完整信用卡號。
          </Li>
        </Ul>
      </InfoPageSection>

      <InfoPageSection title="未成年人資料保護" id="minors">
        <p>若您未滿 16 歲，請在法定代理人或監護人同意下使用本網站與提供個人資料。</p>
      </InfoPageSection>

      <InfoPageSection title="政策更新" id="updates">
        <p>本政策將視法令或服務調整而更新，更新內容將公布於本頁面。最後更新日期：{lastUpdated}</p>
      </InfoPageSection>

      <InfoPageSection title="聯絡我們" id="contact">
        <Ul>
          <Li>
            LINE 官方帳號：
            <ExternalLink href={OFFICIAL_LINE.LINK}>{OFFICIAL_LINE.AT_ID}</ExternalLink>
          </Li>
          <Li>E-mail：{OFFICIAL_EMAIL}</Li>
        </Ul>
      </InfoPageSection>
    </InfoPageLayout>
  );
};

export default PrivacyPolicyPage;
